import React, { useMemo } from "react";
import cn from "classnames";
import { TextBox } from "../text-box";
import { Radio } from "../../ui/radio";
import { useUI } from "../../context";

export const Step2 = (props) => {
  const {
    page_settings: { step2 },
    products,
  } = useUI();

  const productType = useMemo(() => {
    return products[0].type.map((i) => i.value);
  }, [products]);

  return (
    <>
      <TextBox title={step2.title} />
      <div className="flex flex-col gap-6 lg:flex-row lg:gap-5">
        <div
          className={cn("flex-1", {
            hidden: !productType.includes(step2.valueCheckbox1),
          })}
        >
          <Radio
            icon="user"
            label={step2.labelCheckbox1}
            value={step2.valueCheckbox1}
            name={step2.fieldObjective}
            register={props.register}
            defaultChecked={productType.length === 2 || productType.includes(step2.valueCheckbox1)}
            disabled={productType.length === 1 && !productType.includes(step2.valueCheckbox1)}
          />
        </div>
        <div
          className={cn("flex-1", {
            hidden: !productType.includes(step2.valueCheckbox2),
          })}
        >
          <Radio
            icon="buildings"
            label={step2.labelCheckbox2}
            value={step2.valueCheckbox2}
            name={step2.fieldObjective}
            register={props.register}
            defaultChecked={productType.length === 1 && productType.includes(step2.valueCheckbox2)}
            disabled={productType.length === 1 && !productType.includes(step2.valueCheckbox2)}
          />
        </div>
      </div>
    </>
  );
};
